import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar5Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar5 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar5Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar5">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="skin"
            d="M203.838 262.469c-14.916-5.2-21.957-75.57-21.606-75.435 6.658 2.557 18.261-1.394 23.231-11.444 4.969-10.051 4.173-24.004-2.485-26.56-2.596-.995-7.598.287-9.605.486.072-.701.128-1.402.176-2.103 2.931-42.687-2.74-65.91-71.636-76.796-20.627-3.258-44.36 44.598-45.228 82.921-.963 14.088-7.008 15.251-5.893 27.284 18.564 38.052 17.847 65.536 50.922 54.808 1.624 11.684 5.981 31.586 2.954 34.588-1.823 1.816-1.68 3.186-8.099 3.186 0 0 .271 26.201 6.817 27.587.422.087.868.175 1.298.263a153.16 153.16 0 0 0 46.231 1.226l33.353-38.012a1.192 1.192 0 0 0-.446-1.991l.016-.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector"
            d="M156.429 246.716c-11.357 11.818-23.558 15.155-31.514 15.498.581-6.324-3.289-18.978-3.194-26.592 33.155-4.85 54.044-39.7 58.432-45.49-.024.398-11.739 44.112-23.724 56.584Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="Vector_2"
            d="M94.549 137.825c9.151 16.23-9.175 35.193-5.336 40.385 2.684 3.624 16.334 2.772 15.968 6.491-5.36 1.903-21.957-1.123-20.85-6.69-.637-3.974 17.083-22.084 5.137-39.653 1.545 1.84 5.224.263 5.08-.525v-.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="Vector_3"
            d="M75.625 129.486a268.798 268.798 0 0 0-1.712 6.969c11.078 2.883 18.915 9.334 20.786 6.443 1.282-1.983 2.485-10.146-19.082-13.404l.008-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_4"
            d="M152.439 142.173c.374.375-.024.996-.51.805-3.95-1.537-12.575-4.659-19.966-5.758-11.707-1.737-20.841 6.18-22.737-.375-1.282-4.42 1.386-9.779 22.801-6.18 9.119 1.537 13.786 4.858 20.412 11.5v.008Z"
            fill="#000"
          />
          <Path
            id="Vector_5"
            d="M145.629 152.813c-1.895-.318-4.962-5.296-15.14-7.008-10.17-1.712-18.85 9.238-18.85 9.238s5.192-2.063 10.592-3.257a7.74 7.74 0 0 0-.247.987 7.435 7.435 0 0 0 6.1 8.57 7.435 7.435 0 0 0 8.57-6.101 7.592 7.592 0 0 0 .079-1.688c2.955 1.744 5.288 3.671 7.773 3.392 3.982-.446 5.025-5.009 5.025-5.009s-2.015 1.195-3.91.876h.008Z"
            fill="#000"
          />
          <Path
            id="Vector_6"
            d="M95.002 152.821a94.044 94.044 0 0 1-1.57-1.832c-2.89-3.425-5.606-6.65-10.838-7.231a20.045 20.045 0 0 0-2.055-.12c-3.201-.263-9.119 2.334-10.385 3.066-1.266.741-1.17 2.015-.669 3.003a1.83 1.83 0 0 0 2.453.828c.239-.119 4.181-1.943 7.152-3.194a7.028 7.028 0 0 0-.709 2.087 7.018 7.018 0 0 0 5.75 8.084 7.009 7.009 0 0 0 7.765-4.564c.414.486.836.98 1.274 1.489a1.202 1.202 0 0 0 1.712.112c.502-.446.55-1.211.112-1.72l.008-.008Z"
            fill="#000"
          />
          <G id="Group_2" opacity={0.75}>
            <Path
              id="Vector_7"
              d="M116.242 196.017c-3.632-.916-7-3.711-10.919-4.014-3.918-.302-9.102 2.103-9.102 2.103s-.725-2.373-4.404-2.668c-3.68-.295-9.294 6.204-9.294 6.204.254.796 1.696 16.246 13.682 17.194 14.072 1.115 29.251-17.162 30.199-18.166 0 0-6.491.271-10.162-.653Zm-20.157 10.592c-6.682-.525-9.485-6.403-13.037-8.657 3.592 1.84 6.738 3.194 13.427 3.728 14.59 1.154 24.784-1.776 29.403-4.651-4.667 3.209-15.282 10.735-29.793 9.588v-.008Z"
              fill="#2E2017"
            />
          </G>
          <Path
            id="hair"
            d="M81.615 115.693s9-55.652 81.703-55.652c-2.565-2.445-5.448-4.046-5.838-8.49-.382-4.436 4.659-7.892 4.659-7.892s-11.699.19-11.317-12.353c.382-12.543 13.634-7.239 13.634-7.239s2.748-13.132 19.894-13.132c17.147 0 18.835 15.649 18.835 15.649s6.045-12.464 22.944-4.014c16.9 8.45 9.318 23.717 9.318 23.717s17.872-5.073 15.212 15.426c-2.66 20.507-22.22 19.058-22.22 19.058s6.761 4.826 9.175 4.826c-8.697 7.972-28.965 5.877-28.965 5.877s13.108 22.953 11.125 46.773c-1.983 23.82-9.875 56.425-35.137 66.356-.828-3.035-2.429-17.577-2.429-17.577s24.999-2.062 24.999-26.607c0-27.134-27.906-.056-27.906-.056h-7.446s-.191-6.276.749-8.53c.939-2.253-4.691-3.751-4.126-6.944.566-3.194 7.128-3.751 7.128-3.751l-.94-3.942s-12.384 3.376-24.951-12.568c-12.567-15.944-7.502-23.637-7.502-23.637s-11.444-8.442-16.135-8.25c-4.691.19-11.444 1.314-11.444 1.314s1.314-14.256 10.504-18.381c-12.567 8.25-15.386 18.38-15.386 18.38s-16.024-2.707-28.177 21.631l.04.008Z"
            fill={c.hair}
          />
          <Path
            id="Vector_8"
            d="M123.402 300.983c-6.554-1.386-6.817-27.588-6.817-27.588 6.419 0 6.267-1.369 8.099-3.185 1.625-1.617 1.115-8.131.04-15.626-25.955.749-48.803 2.318-54.06 5.161-4.332 2.35-7.995 7.263-10.958 12.766 18.715 14.312 40.855 24.37 64.986 28.726-.43-.087-.868-.175-1.29-.262v.008Z"
            fill="#000"
          />
          <Path
            id="Vector_9"
            d="M196.638 254.29c2.151 4.268 4.556 7.255 7.2 8.179a1.193 1.193 0 0 1 .446 1.991l-33.353 38.012c26.177-3.282 50.276-13.244 70.561-28.105-7.949-7.032-21.479-18.246-28.121-19.305-1.904-.303-8.028-.581-16.725-.772h-.008Z"
            fill="#000"
          />
        </G>
      </G>
    </Svg>
  );
};
